import { useEffect, useMemo } from "react"
import { BrowserRouter, Route, Routes } from "react-router-dom"
import CssBaseline from "@mui/material/CssBaseline"
import { ThemeProvider } from "@mui/material/styles"

import { CacheProvider } from "@emotion/react"
import { createCustomTheme } from "config/theme"
import { createEmotionCache } from "config/cache"

import HomePage from "components/views/home"
import LoginPage from "components/views/auth/login"
import RegistrationPage from "components/views/auth/registration"
import ResetPasswordPage from "components/views/auth/reset_password"
import EmailConfirmationPage from "components/views/auth/email_confirmation"
import TermsAndConditionsPage from "components/views/auth/terms_and_conditions"

import ClientHomePage from "./views/client/home"
import AnamnesisPage from "./views/client/new_anamnesis"
import Last_screening from "./views/client/last_screening"
import HistoryOfRequests from "./views/client/history"
import PersonalData from "./views/client/personal_data"
import Backdrop from "./shared/Backdrop"
import GlobalAlert from "./shared/GlobalAlert"
import PersonalDataPassword from "./views/client/personal_data_password"
import PersonalDataPhysiological from "./views/client/personal_data_physiological"
import HistoryAnamnesis from "./views/client/history_anamnesis"
import useAppStore from "store/app"
import useLanguage from "hooks/use_language"

const App = () => {
  const { direction, mode } = useAppStore((state) => state.meta)
  const { initLanguage } = useLanguage()

  const theme = useMemo(() => createCustomTheme(mode, direction), [mode, direction])

  const cache = useMemo(() => createEmotionCache(direction), [direction])

  useEffect(() => {
    initLanguage()
  }, [])

  return (
    <CacheProvider value={cache}>
      <ThemeProvider theme={theme}>
        <div dir={direction}>
          <CssBaseline />
          <Backdrop />
          <GlobalAlert />

          <BrowserRouter>
            <Routes>
              <Route path="" element={<HomePage />} />
              <Route path="login" element={<LoginPage />} />
              <Route path="registration" element={<RegistrationPage />} />
              <Route path="reset_password" element={<ResetPasswordPage />} />
              <Route path="email_confirmation" element={<EmailConfirmationPage />} />
              <Route path="terms_and_conditions" element={<TermsAndConditionsPage />} />

              <Route path="me">
                <Route path="" element={<ClientHomePage />} />
                <Route path="last_screening" element={<Last_screening />} />
                <Route path="anamnesis" element={<AnamnesisPage />} />
                <Route path="history_of_requests">
                  <Route path="" element={<HistoryOfRequests />} />
                  <Route path=":id" element={<HistoryAnamnesis />} />
                </Route>
                <Route path="personal_data">
                  <Route path="" element={<PersonalData />} />
                  <Route path="password" element={<PersonalDataPassword />} />
                  <Route path="physiological" element={<PersonalDataPhysiological />} />
                </Route>
              </Route>
            </Routes>
          </BrowserRouter>
        </div>
      </ThemeProvider>
    </CacheProvider>
  )
}
export default App
